<template>
  <ListStacked size="tight">
    <li v-if="results.lines && results.lines.items.length">
      <div class="search-category mrgv0">
        {{ $t('search.categories.lines') }}
      </div>
      <ListStacked size="tight" divided>
        <li v-for="line in results.lines.items" :key="line.username">
          <SearchResult
            type="line"
            :name="$t('users.line-number', { line: line.name })"
            :username="line.username"
            :query="query"
          />
        </li>
      </ListStacked>
    </li>
    <li v-if="results.vehicles && results.vehicles.items.length">
      <div class="search-category mrgv0">
        {{ $t('search.categories.vehicles') }}
      </div>
      <ListStacked size="tight" divided>
        <li v-for="vehicle in results.vehicles.items" :key="vehicle.username">
          <UserResult
            :username="vehicle.username"
            :type="vehicle.type"
            :query="query"
          />
        </li>
      </ListStacked>
    </li>
    <li v-if="results.contacts && results.contacts.items.length">
      <div class="search-category mrgv0">
        {{ $t('search.categories.contacts') }}
      </div>
      <ListStacked size="tight" divided>
        <li v-for="contact in results.contacts.items" :key="contact.username">
          <UserResult
            :username="contact.username"
            :type="contact.type"
            :query="query"
          />
        </li>
      </ListStacked>
    </li>
    <li v-if="results.groups && results.groups.items.length">
      <div class="search-category mrgv0">
        {{ $t('search.categories.groups') }}
      </div>
      <ListStacked size="tight" divided>
        <li v-for="group in results.groups.items" :key="group.username">
          <SearchResult
            type="group"
            :name="group.name"
            :username="group.username"
            :query="query"
          />
        </li>
      </ListStacked>
    </li>
  </ListStacked>
</template>

<script>
import UserResult from '@/components/search/UserResult';
import SearchResult from '@/components/search/SearchResult';

export default {
  components: {
    UserResult,
    SearchResult,
  },

  props: {
    query: {
      type: String,
      required: true,
    },
    results: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.search-category {
  padding: $spacing-unit-tiny $spacing-unit-small;

  font-size: rem(14px);
  text-transform: uppercase;

  background-color: $alt-100;
}
</style>
